import MobileDetect from "mobile-detect";
// eslint-disable-next-line
import * as libs from "./../common/default_libs";

// Allow forEach on the return of querySelectorAll
NodeList.prototype.forEach = Array.prototype.forEach;

function goToTouch() {
  require.ensure(
    [],
    (require) => {
      require("./../touch/home");
    },
    "touch",
  );
}

function goToWeb() {
  require.ensure(
    [],
    (require) => {
      require("./../web/home");
    },
    "web",
  );
}

const md = new MobileDetect(navigator.userAgent);
// mobile or tablet:
if (md.mobile()) {
  goToTouch();
} else {
  if (
    navigator.platform.indexOf("Mac") > -1 &&
    navigator.maxTouchPoints > 1 &&
    !window.MSStream
  ) {
    goToTouch();
  } else {
    goToWeb();
  }
}
